module.exports = "pegasus/assets/themelp1/webinar/106.png";